import { useRouter } from 'next/router';
import { useEffect } from 'react';

export const useTagManager = (data = {}) => {
  const router = useRouter();
  const _path = router.asPath.split('?')[0];
  const dataString = JSON.stringify(data);
  useEffect(() => {
    const head = document.querySelector('head');
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.id = 'google-analytics';
    script.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(${dataString});
        `;

    head.appendChild(script);

    return () => {
      head.removeChild(script);
    };
  }, [dataString]);
};
